import { render, staticRenderFns } from "./TemplateAddForm.vue?vue&type=template&id=3971e5f8&scoped=true"
import script from "./TemplateAddForm.vue?vue&type=script&lang=js"
export * from "./TemplateAddForm.vue?vue&type=script&lang=js"
import style0 from "./TemplateAddForm.vue?vue&type=style&index=0&id=3971e5f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3971e5f8",
  null
  
)

export default component.exports